import QuestionsHierarchy from './QuestionsHierarchy';

export default QuestionsHierarchy;
